<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

<ng-container #zones></ng-container>

@if (isDeleteAvailable) {
  <div #deleteButton
    (click)="delete.emit(values)"
    class="delete {{forceShowDeleteClass}}"
    data-cy="chip-selector-delete-button">
    <span class="iwp-icon-gen_close_s"></span>
  </div>
}



